module.exports = __webpack_public_path__ + "static/media/icon-operations.0c5a2c76.svg";